import { Helmet } from 'react-helmet-async';

export default function SeoHead({
  title = 'RB Glasfiber A/S - Specialist i glasfiber',
  description = 'RB Glasfiber er specialist i udførsel og reparation af glasfiberopgaver, herunder pumpebrønde, tanke, udkørende reparation og specialløsninger.',
  canonical,
  ogImage = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/img-1762-1-cropresize-1408x704.webp',
}) {
  const fullTitle = title.includes('RB Glasfiber') ? title : `${title} - RB Glasfiber A/S`;

  return (
    <Helmet>
      <html lang="da" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
